var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVendatotal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "442400ba-da82-43c8-9260-63641e35713a"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "903673b8-d3b1-4890-90d5-6a8e9de91091"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.92 0 0 4.69 292.54 333.06)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 18.52 -10.68)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(88,88,88)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-77.84, -59.75)",
    d: "M 94.1387 48.8116 C 95.0414 48.1909 95.6431 49.521 94.7405 50.1418 C 85.0296 57.0628 76.2256 66.2051 68.8477 76.3184 C 74.9437 65.4957 84.6546 54.9346 94.1387 48.8116 Z M 91.204 43.2207 C 92.1809 42.9547 92.4076 44.4622 91.4307 44.7282 C 80.5163 48.2796 69.9029 54.2252 60.497 61.5896 C 68.8477 53.1567 80.5905 46.147 91.204 43.2207 Z M 93.0093 45.5263 C 93.912 45.1716 94.3654 46.5017 93.3844 47.0337 C 82.9976 52.3586 73.2126 59.9004 64.7837 68.8653 C 72.0091 59.1023 82.8493 50.1418 93.0093 45.5263 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 35.79 -28.37)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(88,88,88)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-95.12, -42.06)",
    d: "M 94.588 63.4518 C 95.4907 61.6783 96.7725 60.9689 98.8046 59.989 C 102.419 58.1269 107.234 55.8169 108.89 55.6396 C 111.598 55.4622 112.353 57.7678 113.33 57.5904 C 114.306 57.3244 116.491 50.1373 116.491 50.1373 C 116.264 50.4034 115.436 51.1128 114.607 51.6448 C 113.103 52.7089 112.423 51.3788 112.349 49.6053 C 112.274 47.6544 113.251 38.8668 114.006 37.182 C 115.061 34.4331 115.209 31.6798 112.122 31.6798 C 103.091 31.6798 102.411 39.5762 94.1346 36.7387 C 94.1346 36.7387 96.8426 41.2655 100.684 41.4428 C 104.521 41.5315 106.104 39.4033 107.909 39.9354 C 109.187 40.3787 110.395 43.0434 110.242 46.2357 C 109.946 53.6932 99.7814 54.8459 95.4948 57.6835 C 93.2361 59.1023 93.2361 61.1462 94.588 63.4518 Z M 90.524 27.6894 C 90.524 27.6894 87.0617 25.2952 83.9003 23.7833 L 83.9003 20.6753 C 83.9003 20.6753 78.6327 20.498 73.7402 24.8474 C 75.1705 25.4681 78.2577 26.5322 80.1372 26.8869 C 82.771 27.2461 90.524 27.6894 90.524 27.6894 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 39.11 8.51)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(88,88,88)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-98.44, -78.94)",
    d: "M 114.01 61.9443 C 114.01 61.9443 112.052 66.4712 112.654 71.3527 C 110.77 70.998 107.835 70.6433 104.6 70.8206 C 99.2538 71.1753 94.7405 73.1262 91.3524 73.0375 C 87.8902 72.9488 69.602 67.89 84.2754 75.4317 C 91.4266 79.1605 102.716 83.9489 100.985 95.9288 C 111.372 89.8945 105.651 79.0673 118.222 75.6977 C 116.042 72.2394 113.556 66.2051 114.01 61.9443 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 14.04 2.65)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(88,88,88)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-73.36, -73.08)",
    d: "M 87.9643 108.977 C 95.3423 99.3028 97.3743 86.7908 94.7364 77.8303 C 95.7132 77.7416 96.3933 77.2096 96.7684 76.4115 C 97.7452 74.1947 82.9193 65.3184 87.1359 55.2006 C 83.146 58.5747 77.2767 64.343 73.4352 69.22 C 75.9948 64.2498 82.5443 56.7081 87.4368 52.0926 C 87.3626 51.3832 87.2101 50.7625 87.0617 50.1418 C 82.0208 52.9793 75.0963 57.7722 69.7504 62.831 C 73.1384 58.0382 80.438 51.6492 86.2332 47.7431 C 86.0065 47.2111 85.7056 46.679 85.4789 46.2357 C 79.6838 48.5412 71.8566 52.3586 65.5338 57.2401 C 69.7504 52.4473 77.05 48.0091 83.6736 44.7282 C 76.1473 45.7036 73.9628 48.1023 69.3712 49.6097 C 60.4146 52.536 60.9422 41.0039 65.608 37.1864 C 48.8985 40.8265 42.6499 72.8601 61.3173 80.8452 C 59.4336 77.2051 57.7808 71.1709 59.3594 67.0918 C 68.3201 81.6433 89.2462 80.8452 87.9643 108.977 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -18.2 -38.87)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(88,88,88)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-41.12, -31.56)",
    d: "M 36.6321 45.1716 C 27.824 40.2014 27.0738 23.7834 37.0855 19.1723 C 42.2789 16.7781 49.2777 17.7535 52.439 23.5218 C 49.8794 27.3392 49.051 29.9994 48.375 34.4376 L 45.8154 35.2357 C 45.0611 34.7036 44.7602 33.9942 45.2136 33.0188 C 47.3981 28.8467 48.9026 27.6052 48.9026 27.6052 C 45.8154 22.8124 39.2701 22.1917 34.9793 24.679 L 36.7847 26.8958 C 32.7206 32.1276 33.0957 39.758 36.6321 45.1716 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -3.34 -35.31)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(88,88,88)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-55.98, -35.12)",
    d: "M 51.9115 34.5218 C 46.9448 36.384 40.9229 39.3147 38.7384 42.9503 C 36.4055 37.2707 39.7152 27.5077 47.019 31.3251 L 49.5044 27.8624 L 48.375 20.6753 C 55.5263 16.0598 65.9872 13.843 73.9669 14.5524 C 55.2996 21.5621 58.5392 27.5964 63.2051 32.9212 C 52.3649 38.5122 47.9258 48.7186 46.5697 55.817 C 45.3662 51.2946 45.3662 41.7133 51.9115 34.5218 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -13.62 23.06)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(88,88,88)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-45.71, -93.49)",
    d: "M 10.0634 61.1462 C 3.74068 80.4905 12.0955 106.849 22.9356 114.745 C 19.9268 107.647 20.4502 103.12 20.1493 97.884 C 24.741 110.662 34.6744 118.115 45.7412 121.489 C 45.7412 121.489 42.4315 116.696 39.6452 109.953 C 55.5263 116.253 75.8506 116.785 75.3972 140.833 C 88.492 119.09 85.6356 96.0174 67.9451 82.3527 C 72.2358 93.9779 69.5237 95.9287 65.0104 93.9779 C 49.6569 87.4115 35.882 65.4913 43.0333 46.147 C 22.9356 72.8557 41.9781 93.4458 56.8081 107.288 C 48.6059 104.273 36.4096 97.4362 27.8323 81.8206 C 27.9848 86.0814 28.2074 90.2491 28.3599 93.8892 C 22.4081 91.495 11.4937 77.2096 10.0634 61.1462 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -44.67 -17.85)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(88,88,88)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-14.65, -52.58)",
    d: "M 22.7831 81.8207 C 14.9559 74.1903 11.3411 60.6098 12.4705 48.7186 C 7.50379 54.7529 6.82371 60.4325 6.82371 60.4325 C 5.24509 56.4377 5.69435 50.2261 6.59701 44.9898 C 3.66233 45.6992 0.950219 44.1031 0.426758 40.1083 C 12.0171 40.6404 9.53581 26.1776 28.8792 23.3356 C 19.6959 29.7246 16.9879 33.6307 11.267 43.5666 C 11.267 43.5666 16.3078 39.0398 21.2003 36.9116 C 15.7844 52.3587 17.5155 70.1955 22.7831 81.8207 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -29.83 -10.75)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(88,88,88)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-29.5, -59.68)",
    d: "M 26.5504 39.6694 C 22.7131 48.4525 17.5939 69.8408 31.3687 79.6925 C 25.9486 71.1753 27.3047 55.2893 36.6363 45.1716 C 35.9603 44.4622 36.1087 44.3735 35.1319 43.3094 C 31.7438 43.6641 28.2815 43.0434 26.5504 39.6694 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 3.62 -57.68)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(88,88,88)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-62.94, -12.75)",
    d: "M 102.72 25.4726 L 93.6112 20.059 C 93.6112 20.059 93.537 16.7737 90.4498 15.3549 C 87.3626 14.0248 79.688 14.4681 79.688 14.4681 C 83.3769 5.95097 70.5789 3.55233 65.7647 3.9957 C 67.9492 5.23714 71.8608 8.69987 73.5919 10.7394 C 66.8199 10.296 60.1179 10.3847 53.4201 11.3601 C 54.5494 12.0695 55.6046 12.9562 56.5073 14.1977 C 45.3662 13.3109 35.7337 14.109 23.1624 22.8922 C 27.4531 15.4391 33.85 10.0256 38.8951 7.18354 C 36.1871 7.71559 33.4008 8.60233 30.5403 8.95703 C 37.0114 2.74539 58.3909 -1.16071 72.7634 0.351186 C 81.5716 1.3266 87.7418 4.34596 86.3858 10.2029 C 88.1169 10.2029 90.8249 10.3802 92.8569 11.7104 C 96.0925 13.8385 95.9441 18.9861 95.9441 18.9861 L 102.72 25.4726 Z",
    strokeLinecap: "round"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.2 0 0 5.52 831.73 422.54)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(88,88,88)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-75.15, -53.74)",
    d: "M 95.2581 1.06165 C 95.4166 3.45835 94.5278 5.47752 94.4726 7.9227 C 95.0996 8.26212 95.861 7.95387 96.5121 7.9227 C 99.1061 7.79109 101.807 8.15129 104.436 8.39719 C 117.092 9.56783 128.392 12.5775 138.479 16.3631 C 142.568 17.8974 146.643 19.2481 150.168 21.4093 C 137.442 18.4065 123.796 15.4383 107.653 16.0479 C 103.819 16.1934 100.074 16.5224 96.5947 16.9934 C 95.4717 17.1458 94.2487 17.132 93.3013 17.7034 C 93.4529 18.3303 94.2659 18.3303 94.7138 18.4134 C 98.7547 19.1685 102.599 20.1001 106.244 21.3331 C 110.457 22.7566 114.674 23.8579 118.639 25.5135 C 125.371 28.3223 132.319 31.1727 138.172 34.9755 C 138.992 35.5089 139.991 35.8483 140.525 36.7107 C 136.236 35.6613 132.023 34.3487 127.817 33.0048 C 117.396 29.673 106.299 27.3837 93.4598 26.3793 C 90.9932 26.1854 88.468 26.2096 86.0083 25.6693 C 85.7706 18.9918 87.4966 13.5993 88.5197 7.92617 C 80.0244 7.70105 72.7107 9.39812 66.241 11.632 C 60.5155 13.6096 55.7855 16.4081 51.1004 19.5183 C 50.494 19.92 49.8498 20.5538 49.0609 20.5434 C 49.1057 18.5104 50.935 17.5926 51.7274 16.0479 C 43.4835 17.4956 36.5005 20.3114 29.9999 24.0138 C 29.0732 24.5402 28.0018 25.174 27.02 25.9845 C 25.3767 27.3421 23.42 28.6929 24.7463 31.4255 C 25.108 32.1702 26.2655 32.8905 26.3137 33.6352 C 26.3792 34.6119 25.1907 35.4154 24.4328 35.8449 C 22.8343 36.7488 21.0016 37.4276 19.3342 38.2104 C 15.0383 40.2261 11.459 42.4635 8.03814 45.4662 C 6.72905 46.6126 5.91603 47.3677 4.979 48.9366 C 4.65172 49.4838 4.07986 50.2492 4.6655 50.9073 C 6.7945 50.703 8.70302 47.7694 11.4108 47.5166 C 13.2366 47.3434 15.1313 48.7704 15.1761 50.5125 C 15.2623 53.8408 11.4866 55.8946 10.4703 58.7935 C 9.53326 61.4569 10.5461 64.5948 12.5097 65.3394 C 14.1289 65.9524 16.2716 65.4156 17.6083 64.6294 C 20.5469 62.8977 22.2693 59.6005 25.0598 57.3735 C 27.4575 55.4582 32.3631 53.5568 36.4351 55.4825 C 38.223 56.3276 39.8766 57.7961 41.1409 59.268 C 43.6282 62.1565 46.3601 65.8035 47.9654 69.4401 C 48.7199 71.151 49.6638 73.5443 49.6121 76.2215 C 49.5742 78.1852 48.9645 80.4088 48.1997 81.898 C 47.2248 83.8029 44.3723 86.7018 41.8471 87.0239 C 40.8343 87.1521 40.0075 87.0066 39.1015 86.6291 C 36.7899 85.6628 35.9287 83.9276 34.7092 81.3439 C 34.1855 84.2324 35.1329 86.7434 36.3559 88.6794 C 37.565 90.5878 39.1911 92.0632 41.4544 93.0156 C 43.4318 93.8503 46.1189 94.7716 49.3779 94.5153 C 50.7352 94.408 51.9306 94.0408 53.064 93.4901 C 53.9769 93.0468 55.5272 92.3056 55.6512 91.4398 C 55.9784 89.1886 53.2604 89.1331 51.9651 88.2846 C 52.0029 87.301 53.0674 86.9616 53.7702 86.5494 C 54.4799 86.1304 55.1896 85.6247 55.9681 85.2887 C 57.6424 84.5649 59.7197 84.3086 61.7729 84.1042 C 66.0619 83.6852 70.7471 84.2255 74.323 85.2091 C 81.5299 87.1936 88.3647 90.1964 93.4633 94.0408 C 93.6493 92.749 92.9362 91.4848 92.4436 90.335 C 90.9209 86.778 89.598 83.3007 87.5792 80.2391 C 85.6535 77.3228 83.1387 74.6456 80.0485 72.7477 C 79.0219 72.1173 77.8265 71.3034 76.4416 71.5666 C 75.4977 72.7615 76.0833 74.9158 76.4416 76.1418 C 76.7896 77.3298 77.3545 78.5593 77.7748 79.768 C 78.2123 81.0253 78.9013 82.1751 78.953 83.3942 C 78.3019 83.3631 77.8231 82.7708 77.3063 82.3691 C 74.3057 80.0313 70.2751 78.0121 66.1687 76.5332 C 65.5417 76.3081 64.522 75.7782 64.05 75.8232 C 62.8064 75.9444 62.1002 78.3965 60.4431 78.2684 C 60.7222 74.8049 61.232 69.3743 59.8162 66.517 C 59.2512 69.9111 58.6311 73.3226 57.5425 76.2942 C 57.2117 77.1982 56.9913 78.3272 56.2093 78.8952 C 55.3756 69.5821 51.7446 62.5063 45.9329 57.9173 C 43.1459 55.718 39.3151 54.0071 34.9503 53.3421 C 30.1721 52.6148 25.6902 53.7716 21.8491 55.3128 C 21.7147 54.8833 22.2349 54.5785 22.476 54.3672 C 24.7222 52.4139 27.3025 50.8207 30.4753 49.6362 C 34.0684 48.2959 38.4504 47.9184 42.8703 47.5062 C 41.5543 46.6126 39.4357 46.6023 37.379 46.481 C 31.0954 46.1105 25.0529 47.4023 20.6709 49.1617 C 21.4735 47.7313 23.0479 46.9694 24.4362 46.1659 C 28.5805 43.7622 33.7997 42.131 39.4184 41.1197 C 36.2077 40.4512 32.2873 41.1023 29.5348 41.5941 C 29.8793 40.4685 31.247 39.9144 32.2804 39.3845 C 33.3725 38.8234 34.561 38.3177 35.6531 37.8086 C 35.1949 37.0328 34.2027 36.8596 33.4552 36.5479 C 31.936 35.9107 30.3857 35.2145 28.7493 34.4976 C 27.8502 34.1028 26.9373 33.7287 26.8649 32.9979 C 26.7616 31.9485 28.3256 30.5354 29.2971 29.9224 C 32.6077 27.8339 37.2343 26.3689 41.2994 25.5065 C 45.4816 24.6199 51.345 24.1142 56.3608 24.8762 C 57.6527 25.0736 60.4121 25.3749 60.4397 26.2165 C 60.4604 26.8642 58.7413 27.1274 58.0868 27.3214 C 53.5601 28.6479 50.0669 30.7086 46.7115 33.2369 C 45.4368 34.1963 44.1312 35.2561 43.1804 36.5479 C 45.9088 36.3332 48.5752 36.1912 51.0246 36.7073 C 57.9386 38.155 64.4807 41.1647 65.2213 48.379 C 65.7484 53.4945 62.1174 57.9796 64.2809 62.3366 C 66.0275 65.8554 72.2801 63.9263 74.3988 62.0214 C 77.5819 59.1641 80.2035 53.0996 80.2035 46.959 C 80.2035 41.9613 79.2148 37.6251 77.3787 34.1824 C 76.7586 33.0187 75.9077 32.0801 75.4977 30.8714 C 78.0022 29.3475 81.33 30.9337 83.1834 32.0559 C 85.2883 33.3269 86.7145 35.2872 88.1235 37.4969 C 89.443 39.5611 90.9036 41.6669 92.3609 43.5683 C 96.8807 49.4838 103.926 52.5975 110.244 56.7397 C 112.311 58.0939 114.088 59.7009 115.814 61.4707 C 119.187 64.9307 122.38 68.9621 123.5 74.4828 C 122.77 74.5486 122.415 73.7867 122.008 73.378 C 118.836 70.1882 115.129 67.5248 110.792 65.3325 C 105.948 62.8838 100.174 61.2006 93.3771 60.9963 C 93.2841 61.9037 93.8112 62.7003 94.0834 63.5211 C 96.0091 69.3708 97.7247 75.6015 98.8684 82.3691 C 100.153 89.9678 101.325 98.5121 100.281 106.973 C 99.113 105.886 97.9521 104.653 96.829 103.423 C 95.7404 102.235 94.6035 101.061 93.3771 99.9529 C 91.0277 97.8298 88.3165 95.679 85.3744 94.0374 C 82.5048 92.4338 78.7911 91.2839 75.1773 90.3315 C 70.6437 89.1366 63.7607 87.5573 59.2546 89.7011 C 59.3545 90.7367 60.1193 90.3073 60.1951 91.1212 C 60.264 91.8554 59.3649 93.0399 58.9411 93.7222 C 56.4918 97.6532 52.3027 100.192 45.9191 99.9529 C 43.7143 99.8698 41.5405 99.1702 39.8801 98.377 C 36.6487 96.8323 33.4931 94.2902 31.8016 91.1212 C 30.0825 87.8967 29.9137 82.1578 32.5078 78.9784 C 32.8833 78.5177 34.7092 76.9523 35.6462 77.9532 C 35.9838 78.3169 35.7806 78.9368 35.8805 79.5291 C 36.2387 81.614 37.8303 84.5476 40.6655 83.9449 C 43.3561 83.3735 44.8787 79.7057 44.5859 76.218 C 42.1641 76.6198 40.228 77.9359 37.4479 77.7177 C 35.3913 76.2596 36.9794 72.7961 37.7614 71.2515 C 38.4228 69.9492 39.3289 68.5084 40.3486 67.2304 C 40.6793 66.8183 41.1995 66.3265 41.2098 65.9697 C 41.2305 65.4087 40.2452 64.3593 39.7182 63.7601 C 37.7752 61.547 34.4577 59.7217 30.2272 60.1304 C 28.6288 60.2863 26.9993 60.8924 26.0692 61.7859 C 28.1603 65.7273 31.0472 68.8721 34.1476 71.8022 C 33.2382 73.1494 31.1712 72.952 29.5968 72.7477 C 24.6326 72.1069 20.5262 70.0393 17.5153 67.5421 C 13.1849 69.5821 8.86493 67.0018 7.5524 63.6769 C 7.24579 62.8977 7.22512 61.8725 6.76694 60.9963 C 6.44311 60.3763 5.39928 59.8395 4.80675 59.3407 C 4.11086 58.7589 3.3943 58.1736 2.92579 57.6056 C 1.64426 56.054 -0.529524 53.5326 0.338611 50.27 C 1.01383 47.7313 3.28407 45.255 4.81019 43.6445 C 8.87871 39.3533 15.3897 36.2016 20.6536 33.1572 C 20.2609 31.661 19.1792 30.5527 19.3997 28.6617 C 19.7097 25.9672 21.7526 23.8891 23.5578 22.431 C 29.0146 18.029 37.0276 15.3968 45.2852 13.9144 C 46.9664 13.6131 48.7578 13.3256 50.5423 13.1248 C 52.3371 12.9239 54.2939 13.0382 55.9543 12.5741 C 57.1601 12.2347 58.5381 10.9982 59.7197 10.2882 C 63.5367 7.98505 67.8498 6.28451 72.349 4.76753 C 78.4363 2.71371 84.775 1.10322 92.2713 0.587167 C 93.1911 0.528289 94.6173 0.296237 95.2581 1.06165 Z M 34.2303 32.2152 C 34.7608 32.7416 36.1354 33.9053 37.0552 33.791 C 37.3997 33.7495 38.0267 33.1953 38.4676 32.9252 C 39.0085 32.5927 39.5149 32.3225 39.9593 32.0593 C 41.0686 31.3909 42.171 30.8333 42.6257 30.1648 C 39.6837 30.7017 36.6452 31.145 34.2303 32.2152 Z M 24.1124 65.9663 C 23.7645 65.5472 23.3442 64.6467 22.8584 64.6259 C 22.3003 64.6017 21.0223 65.8624 21.0533 66.2814 C 21.0912 66.7802 22.0213 67.1612 22.4657 67.4659 C 24.078 68.5708 26.0071 69.5336 28.0362 69.6756 C 26.927 68.4911 25.2114 67.2824 24.1124 65.9663 Z M 43.0942 69.8315 C 41.9264 70.7839 40.7 71.6809 40.1936 73.3018 C 41.5302 73.1979 43.0839 72.6334 44.1932 72.0411 C 44.1381 70.9882 43.7557 70.2713 43.0942 69.8315 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -3.94 -35.1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(88,88,88)",
      fillRule: "evenodd",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-71.21, -18.64)",
    d: "M 74.0805 20.1488 C 72.8058 20.1835 71.2969 20.9905 70.5494 21.9637 C 70.1291 22.5109 70.0464 23.4737 69.4504 23.9344 C 68.2826 24.8349 64.8307 24.3119 63.4114 23.8547 C 61.868 23.3594 59.3532 22.5213 59.1741 21.174 C 59.0018 19.8683 60.5314 18.521 61.2927 17.863 C 63.0049 16.3737 65.282 15.0715 67.8037 13.9978 C 70.4529 12.8687 72.9574 11.944 76.1957 11.7881 C 78.3798 11.6842 80.557 11.9232 81.687 12.8133 C 82.4656 13.4298 83.2062 14.9953 83.2545 16.1243 C 83.3647 18.6215 80.8223 21.9221 79.4099 23.2209 C 78.6554 23.9136 77.1017 25.015 75.958 25.3509 C 74.9624 25.6453 73.4742 25.5691 73.1331 24.8002 C 72.389 23.0997 74.7454 21.9533 74.0805 20.1488 Z",
    strokeLinecap: "round"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.47 0 0 4.21 563.26 807.44)",
    id: "2b258c69-867c-485d-b745-fde13feabfbd"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(88,88,88)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-38.45, -63.47)",
    d: "M 14.0638 30.5251 C 10.0689 33.4098 4.12146 34.183 0.659668 33.6061 C 12.3623 24.8185 9.8493 2.32567 28.4952 0.237695 C 40.8369 -1.14382 49.2973 4.32337 56.5894 13.8723 C 77.9679 41.8755 66.7278 91.1628 76.2311 126.913 L 30.3888 126.913 C 23.6455 116.368 19.8309 103 21.8225 84.0432 C 16.769 98.4589 17.9843 112.215 23.8376 126.913 C -32.198 76.1701 77.7561 1.68594 23.6808 10.654 C 16.5259 11.8393 19.3173 16.0388 24.8334 17.9776 C 30.8867 20.1009 24.9393 27.3107 22.7399 30.5173 C 21.007 28.6098 18.2548 27.503 14.0638 30.5251 Z",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendatotal);
export default __webpack_public_path__ + "static/media/vendatotal.4a3a5b24a2a7d46080b6df275b2651c6.svg";
export { ForwardRef as ReactComponent };